import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import Select from 'react-select-legacy';
import Routes from 'utils/routes.js.erb';
import { downloadPDF } from '../../../actions/download';

export default class ProgramContentEntriesTableRow extends React.Component {
  state = {
    locale: 'en',
    isDownloading: false,
  }

  static propTypes = {
    programContentEntry: PropTypes.object.isRequired,
    allowSend: PropTypes.bool.isRequired,
    onSendClick: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);

    this.handleSendClick = this.handleSendClick.bind(this);
  }

  render() {
    const { programContentEntry, allowSend } = this.props;

    const locales = Object.entries(programContentEntry.locales).map(([k, v]) => ({ value: k, label: v }));
    const clsPDF = classNames('o-sp-button o-sp-button--survey-download o-sp-button--sufixed', { 'u-disabled': this.state.isDownloading });

    return (
      <tr>
        <td>{programContentEntry.title}</td>
        <td>{programContentEntry.pushNotificationText}</td>
        {allowSend && (
          <td>
            <a className='c-send-link u-underlined' onClick={this.handleSendClick}>Send</a>
          </td>
        )}
        <td>
          <div className='u-flex u-flex-gap'>
            <div className='u-flex'>
              <div>
                <Select
                  name='locale'
                  className='o-select o-select--prefixed'
                  clearable={false}
                  searchable={false}
                  disabled={this.state.isDownloading}
                  value={this.state.locale}
                  options={locales}
                  onChange={this.handleLocalChange}
                  optionRenderer={this.optionRenderer}
                  valueRenderer={this.optionRenderer}
                />
              </div>
              <button className={clsPDF} onClick={this.handleDownloadClick}>
                {this.state.isDownloading ?
                  <i className='o-spinner-dual'></i> :
                  <i className='fa fa-file-pdf-o'></i>}
              </button>
            </div>
          </div>
        </td>
      </tr>
    );
  }

  handleSendClick() {
    this.props.onSendClick(this.props.programContentEntry);
  }

  handleDownloadClick = async (e) => {
    e.preventDefault();
    const params = { format: 'pdf', locale: this.state.locale }
    const url = Routes.api_dashboard_program_content_entry_path({ id: this.props.programContentEntry.id }, params);
    await downloadPDF(
      url,
      () => this.setState({ isDownloading: true }),
      () => this.setState({ isDownloading: false }),
    );
  }

  handleLocalChange = (e) => {
    this.setState({ locale: e.value });
  }
}
